/* p107 (Oct 3, 2026) Infused Lights: mobile menu sub items.
   On screens up to 1024px, each top level menu item that has a dropdown gets a toggle button.
   Tapping it opens the item's sub links in place (loaded from the theme's own lazy menu URL).
   Desktop is untouched.
   2026-10-10: second-level groups (Crystals, Jewelry...) inside a loaded panel become collapsed accordions too.
   Tapping the group name opens its full collection; tapping +/- expands its sub links. */
(function () {
  var mq = window.matchMedia('(max-width:1024px)');
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function load(li) {
    var lazy = li.querySelector(':scope > .sub-menu > .lazy_menu[data-include]');
    if (!lazy || lazy.getAttribute('data-il-loading')) return;
    lazy.setAttribute('data-il-loading', '1');
    fetch(lazy.getAttribute('data-include'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { var sm = lazy.parentNode; if (sm) { sm.innerHTML = html; groups(sm); } })
      .catch(function () { lazy.removeAttribute('data-il-loading'); });
  }
  function css() {
    if (document.getElementById('il-grp-css')) return;
    var st = document.createElement('style'); st.id = 'il-grp-css';
    st.textContent = '@media (max-width:1024px){#nt_menu_canvas .il-grp{position:relative}' +
      '#nt_menu_canvas .il-grp>ul{display:none!important}' +
      '#nt_menu_canvas .il-grp.il-gopen>ul{display:block!important;position:static!important;opacity:1!important;visibility:visible!important;transform:none!important;pointer-events:auto!important;box-shadow:none!important;background:transparent!important;padding:0 0 6px 14px!important;margin:0!important;min-width:0!important;width:auto!important}' +
      '#nt_menu_canvas .il-grp-toggle{position:absolute;right:0;top:0;width:44px;height:40px;border:0;background:transparent;color:inherit;font-size:20px;line-height:40px;padding:0;cursor:pointer}' +
      '#nt_menu_canvas .il-grp>a{display:block;padding-right:48px!important}}';
    document.head.appendChild(st);
  }
  function groups(sm) {
    css();
    var gs = sm.querySelectorAll('.menu-item.has-children');
    Array.prototype.forEach.call(gs, function (g) {
      var ga = g.querySelector(':scope > a'), ul = g.querySelector(':scope > ul');
      if (!ga || !ul || g.querySelector(':scope > .il-grp-toggle')) return;
      g.classList.add('il-grp');
      function sync(o) { if (o) { ['position:static','opacity:1','visibility:visible','transform:none','pointer-events:auto','display:block'].forEach(function (d) { var p = d.split(':'); ul.style.setProperty(p[0], p[1], 'important'); }); } else { ul.style.setProperty('display', 'none', 'important'); } }
      sync(false);
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'il-grp-toggle'; t.textContent = '+';
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-label', 'Show ' + ga.textContent.trim() + ' links');
      ga.insertAdjacentElement('afterend', t);
      ga.addEventListener('click', function (e) { if (!mq.matches) return; e.preventDefault(); e.stopPropagation(); window.location.href = ga.href; });
      t.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var open = !g.classList.contains('il-gopen');
        g.classList.toggle('il-gopen', open); sync(open);
        t.textContent = open ? '\u2212' : '+';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.setAttribute('aria-label', (open ? 'Hide ' : 'Show ') + ga.textContent.trim() + ' links');
      });
    });
  }
  ready(function () {
    var canvas = document.getElementById('nt_menu_canvas');
    if (!canvas) return;
    var items = canvas.querySelectorAll('.nt_menu > li.has-children');
    Array.prototype.forEach.call(items, function (li, i) {
      var a = li.querySelector(':scope > a');
      if (!a || li.querySelector(':scope > .il-mm-toggle')) return;
      var sm = li.querySelector(':scope > .sub-menu');
      if (sm && !sm.id) sm.id = 'il-mm-sub-' + i;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'il-mm-toggle';
      b.setAttribute('aria-expanded', 'false');
      if (sm) b.setAttribute('aria-controls', sm.id);
      b.setAttribute('aria-label', 'Show ' + a.textContent.trim() + ' links');
      b.innerHTML = '<span aria-hidden="true"></span>';
      a.insertAdjacentElement('afterend', b);
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!mq.matches) return;
        var open = !li.classList.contains('il-open');
        li.classList.toggle('il-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.setAttribute('aria-label', (open ? 'Hide ' : 'Show ') + a.textContent.trim() + ' links');
        if (open) load(li);
      });
    });
  });
})();
